<template>
    <div class="row" >
        <div class="col-xl-3 col-sm-6 mb-3">
            <div class="card text-white bg-success o-hidden h-100">
                <div class="card-body">
                    <div class="">
                        <h6 >R$ {{faturamento}}</h6>
                        <small>Faturamennto hoje</small>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-xl-3 col-sm-6 mb-3">
            <div class="card text-white bg-primary o-hidden h-100">
                <div class="card-body">
                    <div class="">
                        <h6>{{novas_vendas}}</h6>
                        <small>Novas vendas hoje</small>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-xl-3 col-sm-6 mb-3">
            <div class="card text-white bg-secondary o-hidden h-100">
                <div class="card-body">
                    <div class="">
                        <h6>R$ {{ticket_medio}}</h6>
                        <small>Ticket médio hoje</small>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-xl-3 col-sm-6 mb-3">
            <div class="card text-white bg-danger o-hidden h-100">
                <div class="card-body">
                    <div class="">
                        <h6>{{clientes}}</h6>
                        <small>Novos clientes hoje</small>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
	export default {
		name: 'cardListDashFin',
        data(){
            return{
				clientes    : 0,
                ticket_medio: 0,
                novas_vendas: 0,
                faturamento : 0,
				interval		: 0
            }
		},
		computed: {
			getToken(){
				return this.$store.getters.getToken
			}
		},
		methods: {
			getData: function(){
				fetch(server + 'resumos/geral', {
                    method: 'GET',
                    headers: new Headers({
                        'token' : this.getToken
                    })
                })
					.then(response => (response.json()) )
					.then(responseJSON => {
                        if(responseJSON.data == true){
                            this.clientes       = responseJSON.response[0].clients
                            this.ticket_medio   = responseJSON.response[0].ticket
                            this.novas_vendas   = responseJSON.response[0].sales
                            this.faturamento    = responseJSON.response[0].total
                        }else{
                            this.clientes       = 0
                            this.ticket_medio   = 0
                            this.novas_vendas   = 0
                            this.faturamento    = 0
                        }
					})
					.catch(error => {
						console.log('Erro exception', '=>', error)
					})
			},
			syncData: function(){
				this.interval = setInterval(() => {
                    this.getData()
				}, 300)
			}
		},
		mounted(){
			this.getData()
		},
		created(){
			
        },
        beforeRouterEnter(to, from, next){
            this.syncData()
        },
        beforeRouterLeave(to, from, next){
            clearInterval(this.interval)
        }
	}
</script>

<style scoped>
</style>
